/*
 * parallax effect on two overlapping images
 */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

let images = '.timeline__container .timeline__img-parallax'
// tween all .timeline images
gsap.utils.toArray(images).forEach((img) => {
  gsap.to(img, {
      scrollTrigger: {
        markers: false,
        trigger: img,
        scrub: true,
        start: "top 75%"    //start on top of image at 75% viewport
      },
      y: +100
    }
  )
})
